const sanitizedValue = props => {
  const { min, max, step, enforceStep } = props

  let { value } = props

  value = parseFloat(value)
  if (isNaN(value)) value = 0

  if (enforceStep) value = Math.round(value / step) * step
  if (max !== undefined) value = Math.min(max, value)
  if (min !== undefined) value = Math.max(min, value)

  return value
}

export default sanitizedValue
